export default class AltImagesElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('alt-images', AltImagesElement);